@if (course) {
<!-- Anzeige-Modus -->
@if (!isEditing) {
<div class="main-content form-group">
  <div class="readonly-grid">
    <div class="readonly-label">Kurs-ID</div>
    <div class="readonly-value">{{ course.courseId }}</div>

    <div class="readonly-label">Kursname</div>
    <div class="readonly-value">{{ course.courseName }}</div>

    <div class="readonly-label">Stundenplan-Name</div>
    <div class="readonly-value">{{ course.timetableName }}</div>

    <div class="readonly-label">Startdatum</div>
    <div class="readonly-value">{{ course.startDate | date: "dd.MM.yyyy" }}</div>

    <div class="readonly-label">Enddatum</div>
    <div class="readonly-value">{{ course.endDate | date: "dd.MM.yyyy" }}</div>

    <div class="readonly-label">Ort</div>
    <div class="readonly-value">{{ course.location?.locationName }}</div>

    <div class="readonly-label">Kursart</div>
    <div class="readonly-value">{{ course.courseType?.courseTypeName }}</div>

    <div class="readonly-label">Ausbildungsberuf</div>
    <div class="readonly-value">{{ course.occupationName }}</div>

    <div class="readonly-label">IHK</div>
    <div class="readonly-value">{{ course.ihk }}</div>

    <div class="readonly-label">Termin APT1</div>
    <div class="readonly-value">{{ course.apt1Date | date: "dd.MM.yyyy" }}</div>

    <div class="readonly-label">Termin APT2</div>
    <div class="readonly-value">{{ course.apt2Date | date: "dd.MM.yyyy" }}</div>

    <div class="readonly-label">Status</div>
    <div class="readonly-value">{{ course.isActive ? "Aktiv" : "Inaktiv" }}</div>
  </div>

  <div class="form-buttons">
    @if (canWriteCourse) {
    <button pButton type="button" label="Bearbeiten" (click)="startEditing()"></button>
    <button pButton type="button" label="Teilnehmer:innen bearbeiten" (click)="showDetails(course)"></button>
    }
    <button
      pButton
      type="button"
      label="Abbrechen"
      class="p-button-secondary"
      icon="pi pi-times"
      (click)="closeDialog()"
    ></button>
  </div>
</div>
}

<!-- Bearbeitungsmodus -->
@if (isEditing) {
<div class="main-content form-group">
  <div style="margin-bottom: 1rem"><b>Kurs-ID:</b> {{ course.courseId }}</div>

  <div class="form-group">
    <label>Kursname:</label>
    <input pInputText type="text" [(ngModel)]="editedCourse.courseName" />
  </div>

  <div class="form-group">
    <label>Stundenplan-Name:</label>
    <p-dropdown
      [options]="timetableNameOptions"
      [(ngModel)]="editedCourse.timetableName"
      [filter]="true"
      [showClear]="true"
      appendTo="body"
    ></p-dropdown>
    <small>Kursname aus dem Stundenplan.</small>
  </div>

  <label for="startDate">Startdatum*</label>
  <p-calendar
    [(ngModel)]="editedCourse.startDateObj"
    inputId="startDate"
    name="startDate"
    [showIcon]="true"
    dateFormat="dd.mm.yy"
    appendTo="body"
  ></p-calendar>

  <label for="startDate">Enddatum*</label>
  <p-calendar
    [(ngModel)]="editedCourse.endDateObj"
    inputId="endDate"
    name="endDate"
    [showIcon]="true"
    dateFormat="dd.mm.yy"
    appendTo="body"
  ></p-calendar>

  <div class="form-group">
    <label>Ort:</label>
    <p-dropdown
      [options]="locations"
      optionLabel="locationName"
      [(ngModel)]="editedCourse.locationId"
      optionValue="locationId"
      appendTo="body"
    ></p-dropdown>
  </div>

  <div class="form-group">
    <label>Kursart:</label>
    <p-dropdown
      [options]="courseTypes"
      optionLabel="courseTypeName"
      [(ngModel)]="editedCourse.courseTypeId"
      optionValue="courseTypeId"
      appendTo="body"
    ></p-dropdown>
  </div>

  <div class="form-group">
    <label>Ausbildungsberuf:</label>
    @if (canReadOccupations) {
    <p-dropdown
      [options]="occupations"
      optionLabel="name"
      optionValue="id"
      [(ngModel)]="editedCourse.occupationId"
      [showClear]="true"
      placeholder="Kein Ausbildungsberuf"
      appendTo="body"
    ></p-dropdown>
    } @else {
    <div class="readonly-value">{{ course.occupationName }}</div>
    }
  </div>

  <div class="form-group">
    <label>IHK:</label>
    <input pInputText type="text" [(ngModel)]="editedCourse.ihk" />
  </div>

  <label for="startDate">Termin APT1</label>
  <p-calendar
    [(ngModel)]="editedCourse.apt1DateObj"
    inputId="apt1Date"
    name="apt1Date"
    [showIcon]="true"
    dateFormat="dd.mm.yy"
    appendTo="body"
  ></p-calendar>

  <label for="apt2Date">Termin APT2</label>
  <p-calendar
    [(ngModel)]="editedCourse.apt2DateObj"
    inputId="apt2Date"
    name="apt2Date"
    [showIcon]="true"
    dateFormat="dd.mm.yy"
    appendTo="body"
  ></p-calendar>

  <div class="form-group checkbox-group">
    <p-checkbox inputId="isActiveCheckbox" [(ngModel)]="editedCourse.isActive" binary="true"> </p-checkbox>
    <label for="isActiveCheckbox" class="checkbox-label">Aktiv</label>
  </div>

  <div class="form-buttons">
    <button pButton type="button" class="p-button-success" icon="pi pi-save" (click)="onSaveCourse()"></button>
    <button
      pButton
      type="button"
      label="Abbrechen"
      class="p-button-secondary"
      icon="pi pi-times"
      (click)="cancelEditing()"
    ></button>
  </div>
</div>
} }
